function defaultLoadCsrfToken(defaultForms) {
    let processed = 0,
        inputElement = document.createElement('input'),
        token = document.querySelector("meta[name='csrf-token']").getAttribute("content"),
        forms = defaultForms && defaultForms.length ? defaultForms : document.getElementsByTagName("form");

    inputElement.setAttribute('type', 'hidden');
    inputElement.setAttribute('name', '_token');
    inputElement.setAttribute('value', token);

    Object.values(forms).forEach((key) => {
        if ($(key).find('[name="_token"]').length == 0) {
            key.insertAdjacentHTML('afterbegin', inputElement.outerHTML);
            processed = 1;
        }
    })

    return processed;
}

function addCsrfTokenToXhttpHtml(html)
{
    let forms,
        formName,
        responseHtmlForm,
        counter = 1,
        processed = 0;

    responseHtmlForm = $('<div></div>').append(html).find('form');
    if (responseHtmlForm.length) {
        responseHtmlForm.each(function (i, v) {
            if ($(v).find('[name="_token"]').length == 0) {
                formName = $(v).attr('name');
                forms = document.getElementsByName(formName);
                processed = defaultLoadCsrfToken(forms);
                if(processed === 0) {
                    var timer = setInterval(function () {
                        forms = document.getElementsByName(formName);
                        processed = defaultLoadCsrfToken(forms);
                        if (counter >= 20 || processed === 1) {
                            clearInterval(timer);
                        }
                        counter++;
                    }, 250);
                }
            }

            return false;
        });
    }
}

function addCsrfTokenToHtmlForm(xhttp) {
    if (xhttp.readyState === 4 && xhttp.status === 200) {
        try {
            var jsonValue = JSON.parse(xhttp.responseText);
            if (jsonValue.hasOwnProperty('html')) {
                  addCsrfTokenToXhttpHtml(jsonValue.html);
            }
            if (jsonValue.hasOwnProperty('iTotalRecords') && jsonValue.iTotalRecords > 0) {
                if ($('.dataTable').length) {
                    $('.dataTable').on('draw.dt', function () {
                        defaultLoadCsrfToken()
                    });
                }
            }

        } catch (_) {
            addCsrfTokenToXhttpHtml(xhttp.response);
        }
    }
}

function addCsrfTokenToIframe() {
    let iframes = document.getElementsByTagName('iframe');
    for (var i = 0; i < iframes.length; i++) {
        let parsedUrl, appendToken = true;
        try {
            parsedUrl = new URL(iframes[i].src);
            if (parsedUrl.hostname !== window.location.hostname) {
                appendToken = false;
            }
        } catch (_) {
            //not a url
        }
        if (appendToken) {
            iframes[i].addEventListener("load", function () {
                let forms = this.contentWindow.document.getElementsByTagName("form");
                if (forms.length) {
                    defaultLoadCsrfToken(forms);
                }
            });
        }
    }
}

(function () {
    let op = XMLHttpRequest.prototype.open,
        token = document.querySelector("meta[name='csrf-token']").getAttribute("content");
    XMLHttpRequest.prototype.open = function (type, url) {
        let parsedUrl,
            localUrl = true,
            resp = op.apply(this, arguments);

        try {
            parsedUrl = new URL(url);
            if (parsedUrl.hostname !== window.location.hostname) {
                localUrl = false;
            }
        } catch (_) {
            //local url
        }

        if (localUrl) {
            if (type !== 'GET') {
                this.setRequestHeader('x-csrf-token', token);
            }
            this.onreadystatechange = function () {
                addCsrfTokenToHtmlForm(this);
            }
        }

        return resp;
    };
}());

$(document).ready(function () {
    addCsrfTokenToIframe();
    defaultLoadCsrfToken();
});
